import { FileImage, Printer, ScanBarcode, ScrollText } from 'lucide-react';

import { defineArea } from '../../app/area';
import { DeviceDetailPage } from './pages/DeviceDetailPage';
import { DevicesPage } from './pages/DevicesPage';
import { PrintJobsPage } from './pages/PrintJobsPage';
import { PrintersPage } from './pages/PrintersPage';
import { TemplatesPage } from './pages/TemplatesPage';

/**
 * OWNER: the `devices-printing` module agent (M9 — docs/MODULES.md).
 * Owns: apps/web/src/areas/devices-printing/**  ·  apps/api/src/modules/devices-printing/**
 *       packages/shared/src/contracts/devices-printing.ts
 *       packages/shared/src/i18n/{sv,en,zh}/devicesPrinting.json  ·  e2e/devices-printing.md
 *
 * Permission split, deliberately: PRINTING is `warehouse.print`, printer
 * ADMINISTRATION is `admin.settings.printers`. The old system gated printing
 * itself on the admin key, so every operator who printed a pallet label also
 * held the right to repoint printers at arbitrary hosts (MODULES.md M9,
 * docs/recon/printing-scanners.md A6 #11).
 */
export default defineArea({
  id: 'devices-printing',
  nav: [
    {
      section: 'devices',
      to: '/devices/scanners',
      labelKey: 'common:nav.devices.scanners',
      icon: ScanBarcode,
      permissions: ['devices.read'],
      order: 10,
    },
    {
      section: 'devices',
      to: '/devices/printers',
      labelKey: 'common:nav.devices.printers',
      icon: Printer,
      permissions: ['admin.settings.printers', 'warehouse.print'],
      order: 20,
    },
    {
      section: 'devices',
      to: '/devices/print-jobs',
      labelKey: 'common:nav.devices.printJobs',
      icon: ScrollText,
      permissions: ['devices.printJobs.read', 'admin.logs.print', 'warehouse.print'],
      order: 30,
    },
    {
      section: 'devices',
      to: '/devices/templates',
      labelKey: 'devicesPrinting:templates.title',
      icon: FileImage,
      permissions: ['warehouse.print', 'admin.settings.printers'],
      order: 40,
    },
  ],
  routes: [
    { path: 'devices/scanners', element: <DevicesPage /> },
    { path: 'devices/scanners/:id', element: <DeviceDetailPage /> },
    { path: 'devices/printers', element: <PrintersPage /> },
    { path: 'devices/print-jobs', element: <PrintJobsPage /> },
    { path: 'devices/templates', element: <TemplatesPage /> },
  ],
});
